<template>
  <div class="recharge">
    <HeaderReturn title="充币">
      <template #right>
        <slot name="right">
          <!-- <van-icon name="todo-list-o" size="20" @click="goLink('/My/records')" /> -->
          <span @click="goLink('/My/records')">历史记录</span>
        </slot>
      </template>
    </HeaderReturn>
    <!-- 币种 -->
    <div class="recharge_val">
      <p>选择币种</p>
      <!-- @change="changeRechareNet" -->
      <el-select
        @change="changeRechareNet"
        v-model="rechareForm.coinName"
        placeholder="请选择币种"
      >
        <el-option
          :label="item.primaryNet"
          :value="item.coinName"
          v-for="(item, index) in udunList"
          :key="index"
        >
        </el-option>
      </el-select>
    </div>
    <!-- 数量 -->
    <div class="recharge_val" style="margin-top: 30px">
      <p>数量</p>
      <el-input v-model="rechareForm.amount" placeholder="请输入数量">
      </el-input>
    </div>
    <!-- 地址 -->
    <div class="recharge_vals">
      <p>地址</p>
      <p class="d-flex justify-between">
        {{ rechareForm.addr | longAddress }}
        <span
          style="color: #f89b19; font-size: 14px"
          v-clipboard:copy="rechareForm.addr"
          v-clipboard:success="onCopy"
          >复制</span
        >
        <!-- <i slot="suffix" class="el-input__icon el-icon-document-copy" v-clipboard:copy="rechareForm.addr"
                    v-clipboard:success="onCopy"></i>  -->
      </p>
    </div>
    <!-- 二维码 -->
    <div class="recharge_qr">
      <div>
        <vue-qr :text="rechareForm.addr" :size="116" :margin="2" />
      </div>
    </div>

    <!-- <div style="margin-top:10px;color: #f89b19;">注：仅支持 (TRC-20) 上的资产</div> -->

    <!-- 备注 -->
    <div class="recharge_val">
      <p>备注</p>
      <el-input
        :rows="4"
        type="textarea"
        v-model="rechareForm.bz"
        placeholder="请输入备注内容"
      >
      </el-input>
    </div>
    <div class="recharge_btn" @click="Tj">
      <el-button :loading="IsLogin">提交</el-button>
    </div>

    <div class="system_dialog">
      <el-dialog title="提示" :visible.sync="dialogVisible" width="90%">
        <div>
          此操作将充入：
          <span style="color: #f89b19 !important; font-size: 15px"
            >{{ rechareForm.amount }}
          </span>
          数量的 {{ rechareForm.coinName }}
        </div>
        <div style="margin-top: 20px">
          <el-input
            v-model="rechareForm.jyPassword"
            placeholder="请输入交易密码"
          >
          </el-input>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="qd">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { NoticeBar, Icon } from "vant";
Vue.use(NoticeBar).use(Icon);
import vueQr from "vue-qr";
import { mainApiData } from "@/request/api.js";
import Axios from "axios";
export default {
  components: {
    vueQr,
  },
  data() {
    return {
      baseApi: "",
      UrlYqhy: "",
      udunList: [
        {
          primaryNet: "USDT",
          coinName: "USDT",
        },
        {
          primaryNet: "FIL",
          coinName: "FIL",
        },
      ],
      rechareForm: {
        coinName: "FIL",
        addr: "",
        amount: "",
        bz: "",
        jyPassword: "",
      },
      dialogVisible: false,
      addrName: "",
      IsLogin: false,
    };
  },
  filters: {
    longAddress(val) {
      if (val == "chainIdError") {
        return "Connect Wallet";
      }
      if (val) {
        return (
          val.substring(0, 10) +
          "..." +
          val.substring(val.length - 25, val.length)
        );
      } else {
        return "Connect";
      }
    },
    //过滤小数点后2位数
    numFilter(value) {
      console.log(value);
      let realVal = "";
      if (!isNaN(value) && value !== "") {
        // 截取当前数据到小数点后两位
        realVal = parseFloat(value).toFixed(2);
      } else {
        realVal = "--";
      }
      return realVal;
    },
  },

  created() {
    this.baseApi = process.env.VUE_APP_IMG;
    this.UrlYqhy = window.location.origin + "/#/reg?promotion=" + "1111";

    this.selecr();
  },
  methods: {
    selecr() {
      Axios.get("https://api.vastcoins.space/ty/assets/getAddrList").then((res) => {
        if (res.data.code == 200) {
          console.log(res.data, "res.data");
          this.rechareForm.addr = res.data.data.data.filter(
            (item) => item["title"].indexOf(this.rechareForm.coinName) != -1
          )[0].valStr;
          // console.log(res.data.data.filter(
          //   (item) => item["title"].indexOf(this.rechareForm.coinName) != -1
          // ),'12');
        }
      });
      // mainApiData.getAddrList().then((res) => {
      //   if (res.data.code == 200) {
      //     this.rechareForm.addr =
      //     res.data.data.filter(
      //       (item) => item["title"].indexOf(this.rechareForm.coinName) != -1
      //     )[0].valStr;
      //     // console.log(res.data.data.filter(
      //     //   (item) => item["title"].indexOf(this.rechareForm.coinName) != -1
      //     // ),'12');
      //   }
      // });
    },
    qd() {
      if (this.rechareForm.jyPassword == "") {
        this.$toast("交易密码不能为空");
        return;
      }
      this.empty();
      this.dialogVisible = false;
    },
    Tj() {
      if (this.rechareForm.amount == "" && this.rechareForm.amount == 0) {
        this.$toast("数量不能为空或者为0");
        return;
      }
      this.IsLogin = true;
      let params = {
        amount: this.rechareForm.amount,
        coinName: this.rechareForm.coinName,
        text: this.rechareForm.bz,
      };
      mainApiData
        .userRecharge(params)
        .then((res) => {
          if (res.data.code == 200) {
            this.$toast("待审核");
            this.IsLogin = false;
            this.empty();
          } else {
            this.$toast(res.data.msg);
            this.IsLogin = false;
            this.empty();
          }
        })
        .catch((err) => {
          this.IsLogin = false;
          this.empty();
        });

      // this.dialogVisible = true;
    },
    empty() {
      this.rechareForm.amount = "";
      this.rechareForm.bz = "";
    },
    changeRechareNet(coinName) {
      this.rechareForm.coinName = coinName;
      this.selecr();
      // this.rechareForm.addr =
      //   coinName != "FIL"
      //     ? "TUWFGsXgNJKpwWi4aX2cQS9xZVMpC6KQmF"
      //     : "f1gg5snao37itvm6t4pjbjpuq7n67fkjjnkpwzwqy";
    },
    onCopy() {
      this.$toast(this.$t("myself.a23"));
    },
    goLink(path) {
      if (path) {
        this.$router.push({
          path,
        });
      } else {
        // 暂未开放
        this.$toast(this.$t("orePond.a42"));
      }
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
// 引入全局的样式
@import "@/assets/scss/base.scss";
::v-deep .van-nav-bar__right {
  color: #f89b19;
  font-size: 12px;
}
.recharge {
  margin: 50px 10px;

  .system_dialog {
    ::v-deep .el-dialog__wrapper {
      background: #090101;
      opacity: 0.8;
    }

    ::v-deep .el-input__inner {
      background: #f89b19;
      border: 0.5px solid #f89b19;

      border-radius: 4px;
      color: #fff;
    }

    ::v-deep .el-dialog,
    ::v-deep .el-button {
      background: #f89b19;

      color: #ffffff;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;

      border-radius: 4px;
    }

    ::v-deep .el-dialog {
      background: url(../../assets/img/page/TC-345X233.png) no-repeat;
      background-size: 100% 100%;
    }

    ::v-deep .el-dialog__title,
    ::v-deep .el-dialog__body {
      color: #ffffff;
    }
  }

  ::v-deep .van-nav-bar__title {
    color: #f89b19;
    font-size: 20px;
    font-weight: 600;
  }

  .recharge_selet {
    margin-top: 20px;
    width: 100%;

    .el-select {
      width: 100%;

      background: transparent;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;
 
      border-radius: 4px;
    }

    ::v-deep .el-input__inner {
      border: 0 !important;
      background: transparent !important;
      color: #fff;
    }
  }

  .recharge_qr {
    margin: 45px 0 35px 0;
    text-align: center;

    img {
      border-radius: 10px;
      border: 1px solid var(--unnamed, #f89b19);
      padding: 9px 8px;
    }
  }

  .recharge_dz {
    ::v-deep .el-input__inner {
      color: #fff;
      background: transparent;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;

      border-radius: 4px;
    }
  }

  .recharge_vals {
    margin: 20px 0;

    p {
      margin: 0 0 20px 0;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;

      /* 白/FE */

      color: #fefefe;
    }

    // ::v-deep .el-input__inner {

    //     color: #fff;
    //     background: transparent;
    //     border: 0;
    //     border-radius: 4px;
    // }
  }

  .recharge_val {
    margin: 20px 0;
    .el-select {
      width: 100%;

      // background:  linear-gradient(to bottom, transparent 0%, #f89b19 80%);
      /* 黄/主题 */

      // border: 0.5px solid #f89b19;
      // box-shadow: 0px 0px 6px 2px rgba(20, 132, 195, 0.25), inset 0px 0px 6px -2px rgba(20, 132, 195, 0.25);
      border-radius: 4px;
    }

    p {
      margin: 0 0 20px 0;
      font-family: "PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;

      /* 白/FE */

      color: #fefefe;
    }

    ::v-deep .el-input__inner {
      color: #fff;
      background: transparent;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;
      border-radius: 4px;
    }

    ::v-deep .el-textarea__inner {
      color: #fff;
      background: transparent;
      /* 黄/主题 */

      border: 0.5px solid #f89b19;
      border-radius: 4px;
    }
  }

  .recharge_btn {
    padding-bottom: 40px;

    .el-button {
      width: 100%;
      background: #f89b19;
      border: 0;
      color: #fefefe;
    }
  }
}
</style>
